import { useCallback, useEffect, useState } from "react";
import type { MaterialAudience } from "../api/types";
import {
  portalBuyerConnectionsApi,
  portalVendorCustomersApi,
} from "../api/connections";

// Vendor Connection v1 — drives the red-dot/count badge on the buyer
// "My Vendors" / vendor "Customers" nav entries (the notifications unread
// precedent: the badge clears when the party first opens the card, which
// stamps the per-party FirstViewedAt). Fetched ONCE per shell mount (the
// sidebar), not per nav item; failure is non-fatal (badge just stays off).
export function useNewConnectionCount(accountType: MaterialAudience | undefined) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      if (accountType === "Buyer") {
        setCount(await portalBuyerConnectionsApi.newCount());
      } else if (accountType === "Vendor") {
        setCount(await portalVendorCustomersApi.newCount());
      } else {
        setCount(0);
      }
    } catch {
      setCount(0);
    }
  }, [accountType]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { count, refresh };
}
